import axios, { AxiosPromise } from "axios";
import IEvent from "../types/IEvent";

export const createEvent = (data: any) => axios.post(`/events`, data);
export const deleteEvent = (id: string | number): AxiosPromise => axios.delete(`/events/${id}`)
export const updateEvent = (id: string | number, event: any): AxiosPromise<any> => axios.patch(`/events/${id}`, event)

export const getEvents = (): AxiosPromise<[data: IEvent[], count: number]> => axios.get('/events')
